import React, { Component } from 'react';
import { base } from '../../base';
import MachineDetailsHeaderView from '../views/MachineDetailsHeaderView';


class MachineDetailsHeaderContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
    }

    componentWillMount() {
        this.valuesRef = base.syncState(`machines/${this.props.extraUser.companyid}/${this.props.machineId}`, {
            context: this,
            // asArray: true,
            state: 'machine',
            then() {
                // const m = data;
                // m.id = params.machineId;
                this.setState({
                    loading: false,
                    // machine: m,
                });
            },
        });
    }

    componentWillUnmount() {
        base.removeBinding(this.valuesRef);
    }

    render() {
        if (!this.state.loading) {
            return (
                <MachineDetailsHeaderView
                    machineId={this.props.machineId}
                    machine={this.state.machine}
                    user={this.props.user}
                    extraUser={this.props.extraUser}
                />
            );
        }
        return (
            <p>
                Loading..
            </p>
        );
    }
}

export default MachineDetailsHeaderContainer;



// WEBPACK FOOTER //
// ./src/components/containers/MachineDetailsHeaderContainer.js